<payee-popup width="620px">
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.TITLE" | translate }}
    </h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.DESCRIPTION" | translate }}
    </div>
  </ng-template>
  <ul class="file-examples top-margin-10">
    <li>
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.EXAMPLES.CONTRACT" | translate }}
    </li>
    <li>
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.EXAMPLES.TERMS" | translate }}
    </li>
    <li>
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.EXAMPLES.ORDER_CONFIRMATION" | translate }}
    </li>
    <li>
      {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.EXAMPLES.PERFORMANCE_CERTIFICATE" | translate }}
    </li>
  </ul>

  <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

  <payee-dropzone
    class="top-margin-25"
    [heading]="'WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.TITLE' | translate"
    [multiple]="true"
    [description]="'WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.DROPZONE_DESCRIPTION' | translate"
    (dropped)="filesDropped($event)"
  ></payee-dropzone>

  @if (files.length > 0) {
    <div class="flex column files top-margin-15">
      @for (file of files; track file; let i = $index) {
        <div class="file flex vcenter">
          <payee-icon name="upload-paper"></payee-icon>
          <span>{{ file.name }}</span>
          <button
            type="button"
            payee-icon-button
            color="white"
            (click)="files.splice(i, 1)"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </div>
      }
    </div>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      <div class="flex vcenter hcenter">
        <span>
          {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.SUBMIT" | translate }}
        </span>
        <payee-icon
          height="10px"
          name="arrow-right-white"
        ></payee-icon>
      </div>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
    >
      <div class="flex vcenter hcenter">
        <span>
          {{ "WORKFLOW_DIALOGS.CLIENT_UPLOAD_CONTRACT.CANCEL" | translate }}
        </span>
        <payee-icon
          height="10px"
          name="arrow-right-grey"
        ></payee-icon>
      </div>
    </button>
  </ng-template>
</payee-popup>
